import React, { useState, useRef, useEffect } from 'react';
import { Info, Plus } from 'lucide-react';
import './PageHeader.css';

const PageHeader = ({ 
  title, 
  description, 
  showButton = false, 
  buttonText, 
  onButtonClick, 
  buttonDisabled = false,
  buttonClassName = "header-btn",
  buttonIcon = null,
  textSize = "medium"
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <>
      <header role="banner" className={`page-header text-${textSize}`}>
        <div className="header-content">
          <div className="title-with-icon">
            <h1 className="page-title">{title}</h1>
            <div className="info-icon-container">
              <button 
                className="info-icon"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                title="Show page information"
                aria-label="Show page information"
              >
                <Info size={20} />
              </button>
              {showTooltip && (
                <div className="tooltip">
                  <p>{description}</p>
                </div>
              )}
            </div>
          </div>
          {showButton && (
            <button 
              onClick={onButtonClick}
              disabled={buttonDisabled}
              className={buttonClassName}
              aria-label={buttonText}
            >
              {buttonIcon && <span className="button-icon">{buttonIcon}</span>}
              {buttonText}
            </button>
          )}
        </div>
      </header>
    </>
  );
};

export default PageHeader;
